import React, { type ReactNode, useEffect } from 'react'
import Cookies from 'js-cookie'
import { http } from 'interfaces'

interface CsrfTokenProviderProps {
  children: ReactNode
}
export const CsrfTokenProvider: React.FC<CsrfTokenProviderProps> = ({ children }) => {
  useEffect(() => {
    const csrfToken = Cookies.get('csrftoken')
    if (csrfToken == null) {
      void http.get('/cookie/', { withCredentials: true }).then((response) => {
        Cookies.set('csrftoken', response.data.csrfToken, { sameSite: 'strict' })
      })
    }
  }, [])

  return <>{children}</>
}
